import { useAuth } from '@/providers/auth.provider'
import { Col, Row } from 'antd'
import moment from 'moment'
import './ReportHeader.style.less'

interface Props {
  data: any
}

function ReportHeader(props: Props) {
  const auth = useAuth()

  return (
    <div className="report-header-container">
      <Row justify={'space-between'}>
        <Col span={8}>
          <img src={auth?.user?.company?.logo?.url_path ?? ''} />
        </Col>
        <Col span={8}>
          <p className="title">INSPECTION REPORT</p>
          <p className="number">
            {props.data.inspectionType} no. {props.data.inspectionNumber}
          </p>
        </Col>
        <Col span={8}>
          <p className="date">Report date: {moment().format('DD MMM YYYY')}</p>
          {/* <p className="date">Page 1 of 4</p> */}
        </Col>
      </Row>
    </div>
  )
}

export default ReportHeader
